import { commonHeader, generateEndpoint } from "~/config/apiConfig";
import { ErrorBoundary } from "~/errors/errorBoundary";

interface ProcessLockRequestBody {
  type: string;
  mode: "edit" | "generate" | "chat";
}

export class ProcessLockApi {
  private getRequestInfo(method: string, requestBody?: object): RequestInit {
    return {
      method: method,
      headers: commonHeader,
      credentials: "include",
      keepalive: true,
      ...{
        body: JSON.stringify(requestBody),
      },
    };
  }

  async lock(
    organization_id: string,
    project_id: string,
    requestBody: ProcessLockRequestBody,
  ): Promise<number | null> {
    const endpoint = generateEndpoint(
      `/organizations/${organization_id}/projects/${project_id}/lock`,
    );
    const requestInfo = this.getRequestInfo("POST", requestBody);

    try {
      const response = await fetch(endpoint, requestInfo);
      if (response.ok) {
        return 0;
      } else {
        const errorMessage = ErrorBoundary(response.status);
        console.error(errorMessage);
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async unlock(
    organization_id: string,
    project_id: string,
    requestBody: ProcessLockRequestBody,
  ): Promise<number | null> {
    const endpoint = generateEndpoint(
      `/organizations/${organization_id}/projects/${project_id}/unlock`,
    );
    const requestInfo = this.getRequestInfo("DELETE", requestBody);

    try {
      const response = await fetch(endpoint, requestInfo);
      if (response.ok) {
        return 0;
      } else if (response.status === 404) {
        // 404は「ロックが既に存在しない」ことを意味するので、正常とみなす
        return 0;
      } else {
        const errorMessage = ErrorBoundary(response.status);
        console.error(errorMessage);
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
